export default "__VITE_ASSET__CjO9wFai__"